import React from "react";
import { SEO, DynamicScript } from "@bluefin/components";
import { Grid, Segment } from "semantic-ui-react";
import { graphql } from "gatsby";

import WebsiteLayout from "../components/WebsiteLayout.jsx";

export default class PaymentPlansPage extends React.PureComponent {
  render() {
    const { data } = this.props;
    const { fishermanBusiness, fishermanBusinessWebsitePage } = data;

    return (
      <WebsiteLayout>
        <SEO
          businessName={fishermanBusiness.name}
          pageName={fishermanBusinessWebsitePage.title}
          title={fishermanBusinessWebsitePage.seoTitle}
          description={fishermanBusinessWebsitePage.description}
          ogUrl={"https://meridianmedspajax.com/payment-plans/"}
        />
        <Grid
          className={"custom-page-payment-plans custom-page-grid"}
          style={{}}
          stackable={true}
        >
          <Grid.Row
            className={"fdliibkhlfhbeagh"}
            style={{ padding: 16 }}
            columns={1}
          >
            <Grid.Column className={"lmgfejcjkdeoembp"} style={{ padding: 16 }}>
              <Segment
                className={""}
                style={{
                  border: "none",
                  boxShadow: "none",
                  background: "none",
                }}
              >
                <React.Fragment
                  key={"JSON__71f9c237-60cf-42e7-a2b5-03fdac3af069"}
                >
                  <div>
                    <DynamicScript
                      type={"application/javascript"}
                      delay={200}
                      body={
                        "(function (w, d, s, o, f, js, fjs) {w[o] = w[o] || function () {(w[o].q = w[o].q || []).push(arguments);};(js = d.createElement(s)), (fjs = d.getElementsByTagName(s)[0]);js.id = o;js.src = f;js.async = 1;fjs.parentNode.insertBefore(js, fjs);})(window, document, 'script', '_hw', 'https://files.withcherry.com/widgets/widget.js');_hw('init', {debug: false,variables: {slug: 'meridian-podiatry',name: 'Meridian Podiatry',images: ',customLogo: ',defaultPurchaseAmount: 1000,customImage: 'https://fisherman.gumlet.io/public/e4411929-368b-487f-804d-153e52234750/ImOiaxwGun5O4qNAjmaWskshEBv3Obb5AlTKJN2zLez2Q8in6l13ixdcQxZBTZ8qpow4Y9F6hssI4wtxIAs0.jpg', imageCategory: 'other',language: 'en',},styles: {primaryColor: '#0eb48d',secondaryColor: '#0eb48d10',fontFamily: 'Open Sans',headerFontFamily: 'Open Sans',}}, ['hero','calculator','howitworks','faq']);"
                      }
                    />
                    <div id={"all"} />
                    <div id={"hero"} />
                    <div id={"calculator"} />
                    <div id={"howitworks"} />
                    <div id={"testimony"} />
                    <div id={"faq"} />
                  </div>
                </React.Fragment>
              </Segment>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </WebsiteLayout>
    );
  }
}

export const query = graphql`
  query {
    fishermanBusiness {
      name
    }
    fishermanBusinessWebsitePage(_id: { eq: 41703 }) {
      title
      seoTitle
      description
    }
  }
`;
